import { useState, useEffect } from "react";
import css from "./Details.module.css";
import Form from "../../../../Components/Form/Form";
import FormType from "../../../../Components/Form/FormType";
import { toast } from "react-toastify";
import Pictures from "../../../../Components/Form/Pictures/Pictures";
import Utils from "../../../../Services/Utills";
import User from "../../../../Services/User";

const CertModal = ({ onClose, onSave, existing, staffBiodata }) => {
	const [uploads, setUploads] = useState(
		existing
			? [{ uploadId: existing.id, value: null, uploadType: "image/png" }]
			: []
	);
	const [isSaving, setIsSaving] = useState(false);
	const [options, setOptions] = useState(null);
	const [expiryNotifications, setExpiryNotifications] = useState([]);

	// Hardcoded expiry notification options
	const expiryNotificationOptions = [
		{ id: 60, label: "60 days before", value: 60 },
		{ id: 30, label: "30 days before", value: 30 },
		{ id: 7, label: "7 days before", value: 7 },
		{ id: 0, label: "On the day of expiry", value: 0 },
	];

	useEffect(() => {
		setOptions({
			Fields: [
				{
					element: FormType.Input,
					required: true,
					label: "Certificate Name",
					name: "name",
					value: existing?.name || "",
					placeholder: "Enter certificate name",
				},
				{
					element: FormType.DateOnly,
					required: true,
					label: "Expiration Date",
					name: "expirationDate",
					value: existing?.expirationDate || "",
				},
				{
					element: FormType.MultiSelectDropDown,
					name: "expiryNotifications",
					label: "Expiry Notification",
					options: expiryNotificationOptions,
					value: existing?.expiryNotifications || [],
				},
			],
		});
	}, [existing]);

	const isValidToSubmit = (data) =>
		data.name &&
		data.expirationDate &&
		uploads.length > 0 &&
		uploads.every((u) => u.uploadId);

	const formatDateToBackend = (dateStr) => Number(dateStr.replace(/-/g, "")); // YYYYMMDD

	const onSubmit = () => {
		if (isSaving || !options) return;

		const formData = Utils.FormObject(options);
		formData.uploads = uploads;

		if (!isValidToSubmit(formData)) {
			toast.error("Please fill all fields and upload certificate.");
			return;
		}

		setIsSaving(true);

		// Send one StaffDocument per upload
		const payloads = formData.uploads.map((u) => ({
			id: existing?.id || null,
			staffId: staffBiodata.id,
			docId: String(u.uploadId),
			docStatus: "Active",
			docName: formData.name,
			docExpirationDate: new Date(formData.expirationDate),
			docNotificationDate: JSON.stringify(formData.expiryNotifications || []),
			createdBy: User.getBiodata().id,
		}));

		// Send each payload individually
		Promise.all(payloads.map((p) => onSave(p)))
			.catch(() => toast.error("Failed to save certification(s)"))
			.finally(() => setIsSaving(false));
	};

	if (!options) return null;

	return (
		<div className={css.ModalOverlay}>
			<div className={css.ModalContent}>
				<h3 className={css.ModalTitle}>
					{existing ? "Edit Certification" : "Add Certification"}
				</h3>

				<Form onSubmit={onSubmit}>{options}</Form>

				<div className={css.UploadSection}>
					<Pictures
						load={uploads}
						onChange={(list) => setUploads(list)}
						onDelete={() => setUploads([])}
						allowedTypes={["image", "document"]}
					/>
				</div>

				<div className={css.ModalActions}>
					<button
						type="button"
						onClick={onClose}
						className={css.CancelBtn}
						disabled={isSaving}
					>
						Cancel
					</button>
					<button
						type="button"
						onClick={onSubmit}
						className={css.SaveBtn}
						disabled={isSaving}
					>
						Save
					</button>
				</div>
			</div>
		</div>
	);
};

export default CertModal;
